import React from 'react'
import { Typography } from 'antd'

const { Text } = Typography

const SystemMessage = ({ content }) => (
    <Text type='secondary'>{content}</Text>
)

export default SystemMessage 